import * as API from "./base";

export const create = (subscription) =>
  API.post("/subscriptions", { subscription });
